import React, { useRef } from 'react';
import { css } from "@emotion/react";
import { motion, useInView } from "framer-motion";

const animCss = css`
    .btn-interactive {
        transition: transform 0.2s ease, box-shadow 0.2s ease;
    }
    .btn-interactive:hover {
        transform: scale(1.05);
    }
    .btn-interactive:active {
        transform: scale(0.97);
    }
`;

const CtaSection: React.FC = () => {
    const ref = useRef(null);
    const isInView = useInView(ref, { once: true, margin: "-100px" });

    return (
        <section css={animCss} className="py-20 md:py-2 px-4 md:px-8 bg-white">
            <div
                ref={ref}
                className="flex flex-col gap-12 md:gap-[30px] justify-center items-center  mx-auto mb-20"
            >
                <div
                    className="w-[104px] h-[104px] md:w-[59px] md:h-[59px] rounded-full bg-main flex justify-center items-center"
                    style={{
                        animation: `bounce 2s ease-in-out infinite 2s`,
                        boxShadow: `0 4px 10px 0 rgba(0, 0, 0, 0.10)`
                    }}
                >
                    <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none" className={"md:w-[23x] md:h-[20px]"}>
                        <path
                            d="M5.78906 20.4953L16.377 30.1276C16.8164 30.5273 17.3965 30.75 18 30.75C18.6035 30.75 19.1836 30.5273 19.623 30.1276L30.2109 20.4953C31.9922 18.8795 33 16.6127 33 14.2432V13.912C33 9.92091 30.041 6.51791 26.0039 5.86129C23.332 5.42735 20.6133 6.2781 18.7031 8.13947L18 8.82464L17.2969 8.13947C15.3867 6.2781 12.668 5.42735 9.99609 5.86129C5.95898 6.51791 3 9.92091 3 13.912V14.2432C3 16.6127 4.00781 18.8795 5.78906 20.4953Z"
                            fill="white"/>
                    </svg>
                </div>

                <motion.h2
                    initial={{opacity: 0, y: 20}}
                    animate={isInView ? {opacity: 1, y: 0} : {}}
                    transition={{duration: 1.2, ease: "easeOut"}}
                    className="text-[40px] md:text-[26px] font-bold text-black leading-[60px] md:leading-[40px] text-center"
                >
                    마음 속 이야기를 통해 <br/>
                    <span className="text-main font-extrabold">독자와 연결되는 공간</span>
                </motion.h2>

                <motion.p
                    initial={{opacity: 0, y: 20}}
                    animate={isInView ? { opacity: 1, y: 0 } : {}}
                    transition={{ duration: 1.2, delay: 0.3, ease: "easeOut" }}
                    className="text-[#6C7B7F] text-2xl md:text-sm font-normal leading-[39px] md:leading-6 text-center whitespace-nowrap"
                >
                    책에서 다하지 못한 말들이 누군가의 마음에 닿을 수 있도록 <br />
                    지금, 북밋에서 그 이야기를 풀어가 보세요.
                </motion.p>
            </div>
        </section>
    );
};

export default CtaSection;
